import { useContext, useRef, useEffect } from 'react';
import { StateContext } from '../../../../../Controllers/context/state';
import StockChartToggle from '../StockChartToggle/StockChartToggle';
import DropdownMenu from '../../../DropdownMenu';
import { PercentileMoves, InfoScore } from '../../constants';
import { DropdownChevron } from '../../../../StyledComponents/UserFormStyledComponents';
import {
    FiltersContainer,
    FilterButton,
    FilterContainer,
    FilterGrid,
    FilterField,
    FilterLabel,
    WideFilterField,
    EventTypesWrapper,
    EventTypesHeader,
    SearchInput,
    ScrollableList,
    EventTypeItem
} from '../../styled-components';

const ChartFilters = ({
    isFiltersOpen,
    setIsFiltersOpen,
    chartType,
    setChartType,
    selectedPercentile,
    handleChangePercentile,
    selectedInfoScore,
    handleChangeInfoScore,
    eventTypes,
    selectedEventType,
    setSelectedEventType,
    isEventTypesOpen,
    setIsEventTypesOpen,
    eventTypeSearch,
    setEventTypeSearch
}) => {
    const filtersRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isFiltersOpen && filtersRef.current && !filtersRef.current.contains(event.target)) {
                setIsFiltersOpen(false);
                setIsEventTypesOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isFiltersOpen, setIsFiltersOpen, setIsEventTypesOpen]);

    return (
        <FiltersContainer ref={filtersRef}>
            <FilterButton onClick={() => setIsFiltersOpen(!isFiltersOpen)}>
                Filters
                <DropdownChevron
                    isOpen={isFiltersOpen}
                    viewBox="0 0 12 8"
                    style={{
                        width: '12px',
                        height: '8px',
                        transform: isFiltersOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                    }}
                >
                    <polyline
                        points="1,1 6,6 11,1"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </DropdownChevron>
            </FilterButton>
            {isFiltersOpen && (
                <FilterContainer>
                    <FilterGrid>
                        <FilterField>
                            <FilterLabel>Chart Type</FilterLabel>
                            <StockChartToggle
                                chartType={chartType}
                                setChartType={setChartType}
                                onToggle={() => setIsFiltersOpen(false)}
                            />
                        </FilterField>
                        <FilterField>
                            <FilterLabel>Percentile Moves</FilterLabel>
                            <DropdownMenu
                                label={PercentileMoves?.label}
                                handleChange={handleChangePercentile}
                                options={PercentileMoves?.values.map(option => ({
                                    ...option,
                                    value: JSON.stringify(option.value)
                                }))}
                                value={JSON.stringify(selectedPercentile)}
                            />
                        </FilterField>
                        <FilterField>
                            <FilterLabel>Info Score</FilterLabel>
                            <DropdownMenu
                                label=""
                                handleChange={handleChangeInfoScore}
                                options={InfoScore?.values}
                                value={selectedInfoScore}
                            />
                        </FilterField>
                        <WideFilterField>
                            <FilterLabel>Event Types</FilterLabel>
                            {eventTypes.length > 0 ? (
                                <EventTypesWrapper>
                                    <EventTypesHeader
                                        onClick={() => setIsEventTypesOpen(!isEventTypesOpen)}
                                        isOpen={isEventTypesOpen}
                                    >
                                        <span>{selectedEventType}</span>
                                        <DropdownChevron
                                            isOpen={isEventTypesOpen}
                                            viewBox="0 0 12 8"
                                            style={{
                                                width: '12px',
                                                height: '8px',
                                                transform: isEventTypesOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                            }}
                                        >
                                            <polyline
                                                points="1,1 6,6 11,1"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </DropdownChevron>
                                    </EventTypesHeader>
                                    {isEventTypesOpen && (
                                        <>
                                            <SearchInput
                                                type="text"
                                                placeholder="Search event types..."
                                                value={eventTypeSearch}
                                                onChange={(e) => setEventTypeSearch(e.target.value)}
                                            />
                                            <ScrollableList>
                                                <EventTypeItem
                                                    onClick={() => setSelectedEventType('All')}
                                                >
                                                    All
                                                </EventTypeItem>
                                                {eventTypes
                                                    .filter(type => type.name.toLowerCase().includes(eventTypeSearch.toLowerCase()))
                                                    .map((type, index) => (
                                                        <EventTypeItem
                                                            key={index}
                                                            onClick={() => setSelectedEventType(type.name)}
                                                        >
                                                            <span>{type.name}</span>
                                                            <span style={{
                                                                color: '#5DD39E',
                                                                fontSize: '12px',
                                                                marginLeft: '8px'
                                                            }}>
                                                                ({type.count})
                                                            </span>
                                                        </EventTypeItem>
                                                    ))}
                                            </ScrollableList>
                                        </>
                                    )}
                                </EventTypesWrapper>
                            ) : (
                                <div style={{
                                    padding: '11px 12px',
                                    background: '#0a1926',
                                    borderRadius: '2px',
                                    border: '1px solid rgba(93, 211, 158, 0.15)',
                                    color: '#94a3b8',
                                    fontSize: '13px',
                                    textAlign: 'center',
                                    height: '44px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    No events in current view
                                </div>
                            )}
                        </WideFilterField>
                    </FilterGrid>
                </FilterContainer>
            )}
        </FiltersContainer>
    );
};

export default ChartFilters;


